const i18next = require('i18next')
const i18nOptions = require('./i18n-options')
const { SHOP_LOCALES } = require('../../constants/shop-language')

const i18nInstance = i18next

if (!i18nInstance.isInitialized) {
  i18nInstance.init(i18nOptions)
}

const getInitialProps = (req, namespaces) => {
  let resultNamespaces = namespaces
  if (!namespaces) {
    resultNamespaces = i18nInstance.options.defaultNS
  }
  if (typeof namespaces === 'string') {
    resultNamespaces = [namespaces]
  }

  req.i18n.toJSON = () => null

  const initialI18nStore = {}

  // Only the page's language and its fallback are needed on the client; other
  // languages load through the backend if the shopper switches. Serialising
  // every loaded language put all shop locales into every page's HTML.
  const languages = [req.i18n.language, ...i18nOptions.fallbackLng].filter(
    (l, index, list) => SHOP_LOCALES.includes(l) && list.indexOf(l) === index,
  )

  // Never ship an empty store (e.g. if shop config ever drops the fallback).
  if (!languages.length) {
    languages.push(i18nOptions.fallbackLng[0])
  }

  languages.forEach((l) => {
    initialI18nStore[l] = {}

    resultNamespaces.forEach((ns) => {
      initialI18nStore[l][ns] = req.i18n.services.resourceStore.data[l]
        ? req.i18n.services.resourceStore.data[l][ns] || {}
        : {}
    })
  })

  return {
    i18n: req.i18n,
    initialI18nStore,
    initialLanguage: req.i18n.language,
  }
}

module.exports = {
  getInitialProps,
  i18nInstance,
  I18n: i18next.default,
}
